import React from 'react';
import {
  ClaimHistory,
  Status,
  Provider,
  ArrayFieldChange,
  RelationFieldChange,
  PrimitiveFieldChange,
} from 'interfaces';
import {
  InternalComment,
  DebitChanges,
  PrimitiveChange,
  RelationChanges,
  TariffChanges,
  getDisplayableClaimChanges,
} from 'pages/claims/components/ClaimHistoryTimeline';

import { Stack } from '@mantine/core';

interface ClaimTimelineItemProps {
  claimVersion: ClaimHistory;
  status: Status[];
  providers: Provider[];
  green: string;
  red: string;
}

export const ClaimTimelineItem: React.FC<ClaimTimelineItemProps> = ({
  claimVersion,
  status,
  providers,
  green,
  red,
}) => {
  const changesArray = getDisplayableClaimChanges(claimVersion.changes);

  const orderMap = { primitive: 1, relation: 2, array: 3, internalComments: 4 };
  const sortedChanges = [...changesArray].sort(
    (a, b) =>
      (orderMap[a.field as keyof typeof orderMap] ||
        orderMap[a.type as keyof typeof orderMap]) -
      (orderMap[b.field as keyof typeof orderMap] ||
        orderMap[b.type as keyof typeof orderMap])
  );

  return (
    <Stack gap={0}>
      {sortedChanges.map((change, index) => {
        if (change.type === 'activity') {
          return null;
        } else if (change.field === 'tariffs' && change.type === 'array') {
          return (
            <TariffChanges
              key={`${claimVersion.id}-tariffs-${index}`}
              changeDetails={change as ArrayFieldChange}
              green={green}
              red={red}
            />
          );
        } else if (change.field === 'internalComments') {
          return (
            <InternalComment
              key={`${claimVersion.id}-internalComments-${index}`}
              comment={change.after?.toString() ?? ''}
            />
          );
        } else if (change.field === 'debits' && change.type === 'array') {
          return (
            <DebitChanges
              key={`${claimVersion.id}-debits-${index}`}
              changeDetails={change as ArrayFieldChange}
              green={green}
              red={red}
            />
          );
        } else if (change.field === 'claimHistories') {
          return null;
        } else if (change.type === 'primitive') {
          return (
            <PrimitiveChange
              key={`${claimVersion.id}-${change.field}-${index}`}
              changeDetails={change as PrimitiveFieldChange}
              field={change.field}
              status={status}
              providers={providers}
              red={red}
              green={green}
            />
          );
        } else if (change.type === 'relation') {
          return (
            <RelationChanges
              key={`${claimVersion.id}-${change.field}-${index}`}
              field={change.field}
              changeDetails={change as RelationFieldChange}
              green={green}
              red={red}
              status={status}
              providers={providers}
            />
          );
        } else {
          return null;
        }
      })}
    </Stack>
  );
};
